import { isCompleted, isTargetedForConversation, setIsTargetedForConversation } from "../Helpers/Storage";


class WebsiteConfigurationProcessor {
  processConfiguration = (websiteConfiguration) => {
    const filteredConversations = [];
    websiteConfiguration.configuration.forEach((websiteConversation) => {
      const validConversation = this.processFilters(websiteConversation);
      if (validConversation) {
        filteredConversations.push(websiteConversation);
      }
    });
    let alwaysOnConversation = filteredConversations.find(conversation => conversation.web_tag_type === "Always-On");
    if (alwaysOnConversation && isCompleted(alwaysOnConversation.survey_id)) {
      alwaysOnConversation = null;
    }
    const digitalInterceptConversations = filteredConversations.filter(conversation => conversation.web_tag_type === "Digital Intercept" && !isCompleted(conversation.survey_id));

    this.unhookedButtons = {};
    digitalInterceptConversations.forEach(conversation => {
      this.setupDigitalInterceptSources(conversation);
    });
    this.hookUnhookedButtons().then();

    return {
      alwaysOn: alwaysOnConversation,
      digitalIntercepts: digitalInterceptConversations
    };
  };
  processFilters = (websiteConversation) => {
    let validConversation = true;
    websiteConversation.configuration.filters.forEach((filter) => {
      let validFilter = true;
      switch (filter.type) {
      case "url":
        validFilter = this.processURLFilter(filter);
        break;
      case "device_type":
        validFilter = this.processDeviceTypeFilter(filter);
        break;
      case "user_sample":
        validFilter = this.processUserSampleFilter(websiteConversation, filter);
        break;
      }
      if (!validFilter) {
        validConversation = false;
      }
    });
    return validConversation;
  };

  processURLFilter = (urlFilter) => {
    const currentLocation = window.location.pathname.split(".")[0];
    let foundLocationMatch = false;
    urlFilter.value.forEach((possibleLocation) => {
      if (possibleLocation === currentLocation) {        
        // Deprecated, use regex instead
        foundLocationMatch = true;
      } else if (possibleLocation.slice(-1) === "*") {
        // Deprecated, use regex instead
        const globalDirectory = possibleLocation.slice(0, -1);
        const currentDirectory = currentLocation.substring(0, globalDirectory.length);
        if (globalDirectory === currentDirectory && currentDirectory.slice(-1) === "/") {
          foundLocationMatch = true;
        }
      }

      if (!foundLocationMatch) {
        try {
          const regexPattern = new RegExp(possibleLocation);
          const match = currentLocation.match(regexPattern);
          if (match && match[0] === currentLocation) {
            foundLocationMatch = true;
          }
        } catch (e) {
          // we don't want to throw an error if the regex pattern is invalid
        }
      }
    });
    return foundLocationMatch;
  };

  processDeviceTypeFilter = (deviceTypeFilter) => {
    let currentDevice = "desktop";
    const ua = navigator.userAgent;
    if (/(tablet|ipad|playbook|silk)|(android(?!.*mobi))/i.test(ua)) {
      currentDevice = "tablet";
    }
    if (
      /Mobile|iP(hone|od)|Android|BlackBerry|IEMobile|Kindle|Silk-Accelerated|(hpw|web)OS|Opera M(obi|ini)/.test(
        ua
      )
    ) {
      currentDevice = "mobile";
    }
    return deviceTypeFilter.value.includes(currentDevice);
  };

  processUserSampleFilter = (conversation, userSampleFilter) => {
    let hasBeenTargeted = isTargetedForConversation(conversation);
    if (hasBeenTargeted === null) {
      const random = Math.floor(Math.random() * 100);
      hasBeenTargeted = random < userSampleFilter.value;
      setIsTargetedForConversation(hasBeenTargeted, conversation);
    }
    return hasBeenTargeted;
  };

  setupDigitalInterceptSources = (digitalInterceptConversation) => {
    digitalInterceptConversation.configuration.sources.forEach(source => {
      switch (source.type) {
      case "behavioural":
        this.setupBehaviouralSource(source.value, digitalInterceptConversation.survey_id);
        break;
      case "timeout":
        this.setupTimeoutSource(source.value, digitalInterceptConversation.survey_id);
        break;
      case "button":
        this.setupButtonSource(source.value, digitalInterceptConversation.survey_id);
        break;
      }
    });
  };

  setupBehaviouralSource = (behaviouralConfiguration, surveyId) => {
    let timeoutId = null;
    const exitListener = (e) => {
      if (e.clientY < 0 && behaviouralConfiguration.navbar_enter.enabled) {
        timeoutId = setTimeout(() => {
          this.dispatchConversationInitiation(surveyId);
        }, behaviouralConfiguration.navbar_enter.delay);
      } else if ((e.clientX < 0 || e.clientX > window.innerWidth || e.clientY > window.innerHeight) && behaviouralConfiguration.window_exit.enabled) {
        timeoutId = setTimeout(() => {
          this.dispatchConversationInitiation(surveyId);
        }, behaviouralConfiguration.window_exit.delay);
      }
    };
    document.addEventListener("mouseout", exitListener);

    const enterListener = (e) => {
      clearTimeout(timeoutId);
    };
    document.addEventListener("mouseenter", enterListener);
  };

  setupTimeoutSource = (timeoutConfiguration, surveyId) => {
    if (timeoutConfiguration.activity_timeout.enabled) {
      let counter = 0;
      let interval = setInterval(() => {
        counter++;
        if (counter >= timeoutConfiguration.activity_timeout.delay) {
          this.dispatchConversationInitiation(surveyId);
        }
      }, 1000);
    }
    if (timeoutConfiguration.inactivity_timeout.enabled) {
      let counter = 0;
      let interval = setInterval(() => {
        counter++;
        if (counter >= timeoutConfiguration.inactivity_timeout.delay) {
          this.dispatchConversationInitiation(surveyId);
        }
      }, 1000);
      let refreshEvents = ["mousemove", "scroll", "keydown"];
      const resetInactivity = () => counter = 0;
      refreshEvents.forEach((e) => {
        document.addEventListener(e, resetInactivity);
      });
    }
  };

  setupButtonSource = (buttonConfiguration, surveyId) => {
    buttonConfiguration.forEach((button) => {
      this.setupButton(button, surveyId);
    });
  };

  setupButton = (button, surveyId) => {
    let domElement;
    switch (button.selector_type) {
    case "id":
      domElement = document.getElementById(button.selector_value);
      break;
    case "classname":
      const foundElements = document.getElementsByClassName(button.selector_value);
      if (foundElements.length > 0) {
        domElement = foundElements[0];
      }
      break;
    case "query_selector":
      domElement = document.querySelector(button.selector_value);
      break;
    }
    const stringifiedButton = JSON.stringify(button);
    if (domElement) {
      domElement.addEventListener("click", () => {
        this.dispatchConversationInitiation(surveyId);
      });
      console.debug("[WebsiteConfigurationProcessor.js] Hooked button '" + stringifiedButton + "' to trigger survey id " + surveyId + ".");
      delete this.unhookedButtons[stringifiedButton];
    } else {
      console.debug("[WebsiteConfigurationProcessor.js] Could not hook button '" + stringifiedButton + "' to trigger survey id " + surveyId + " because the referenced element was not found.");
      this.unhookedButtons[stringifiedButton] = surveyId;
    }
  };

  dispatchConversationInitiation = (surveyId) => {
    // TODO: Handle trigger conditions for conversation
    const event = new Event("chatter-open-conversation");
    event.surveyId = surveyId;
    document.dispatchEvent(event);
  };

  async hookUnhookedButtons() {
    const waitTimeBetweenRetriesInMs = 1000;
    while (Object.keys(this.unhookedButtons).length > 0) {
      for (const key in this.unhookedButtons) {
        const button = JSON.parse(key);
        const surveyId = this.unhookedButtons[key];
        this.setupButton(button, surveyId);
      }

      await this.sleep(waitTimeBetweenRetriesInMs);
    }
  }

  sleep = (ms) => new Promise(ignored => setTimeout(ignored, ms));
}

export default new WebsiteConfigurationProcessor();